module.exports = __webpack_public_path__ + "static/media/app-pawdate-chat.68653572.jpeg";